<template>
    <div class="popup filter-popup visible" id="filter-popup">
        <div class="popup-box">
            <div class="title-popup-wrap">
                <span class="reset">reset</span>
                <p class="title">Filter</p>
                <span class="js-close-popup" @click.prevent="closePopup">
                    <icon-base width="20" height="20" viewBox="0 0 20 20" fill="none"><icon-cross/></icon-base>
                </span>
            </div>
            <div class="filter-popup-item" @click.prevent="openFilterItem" :class="open ? 'active' : ''">
                <div class="item-wrap">
                    <span>Customer</span>
                    <div class="arrow-icon">
                        <icon-base width="19" height="11" viewBox="0 0 19 11"><icon-filter-arrow-down/></icon-base>
                    </div>
                </div>
                <div class="select-result" v-if="searchParam">
                    <p>{{searchParam}}</p>
                </div>
                <div class="filter-dropdown-box" :style="!open ? 'display:none' : ''" >
                    <select2 :options="options" v-model="searchParam" placeholder="Customer"  name="select" class="select select-search" data-placeholder="Customer"/>
                    <!--<select name="select" class="select select-search select2-hidden-accessible" data-placeholder="Customer" data-select2-id="110" tabindex="-1" aria-hidden="true">
                        <option data-select2-id="112"></option>
                        <option value="France Televisions" data-select2-id="133">France Televisions</option>
                        <option value="Priveet Canal" data-select2-id="134">Priveet Canal</option>
                        <option value="ABC Channel" data-select2-id="135">ABC Channel</option>
                        <option value="NBC UK" data-select2-id="136">NBC UK</option>
                        <option value="Gulli" data-select2-id="137">Gulli</option>
                        <option value="France Ô" data-select2-id="138">France Ô</option>
                    </select><span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;below" dir="ltr" data-select2-id="111" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-m5-container"><span class="select2-selection__rendered" id="select2-select-m5-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">Customer</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                </div>
            </div>
            <div class="filter-popup-item">
                <div class="item-wrap">
                    <span>LX Terminal</span>
                    <div class="arrow-icon">
                        <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
                        </svg>
                    </div>
                </div>
                <div class="select-result">
                    <p></p>
                </div>
                <div class="filter-dropdown-box" style="display: none;">
                    <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="LX Terminal" data-select2-id="113" tabindex="-1" aria-hidden="true">
                        <option data-select2-id="115"></option>
                        <option value="Cobham 6075 LX">Cobham 6075 LX</option>
                        <option value="Paradigm Hornet 100GX">Paradigm Hornet 100GX</option>
                        <option value="Cobham 5075 GX">Cobham 5075 GX</option>
                        <option value="Paradigm Connect 100T">Paradigm Connect 100T</option>
                    </select><span class="select2 select2-container select2-container--default" dir="ltr" data-select2-id="114" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-bq-container"><span class="select2-selection__rendered" id="select2-select-bq-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">LX Terminal</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
                </div>
            </div>

            <div class="filter-popup-item">
                <div class="item-wrap">
                    <span>Active Subscription</span>
                    <div class="arrow-icon">
                        <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
                        </svg>
                    </div>
                </div>
                <div class="select-result">
                    <p></p>
                </div>
                <div class="filter-dropdown-box" style="display: none;" data-select2-id="140">
                    <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="Phone number" data-select2-id="119" tabindex="-1" aria-hidden="true">
                        <option data-select2-id="121"></option>
                        <option value="LX EVENT-512/4096 24M" data-select2-id="141">LX EVENT-512/4096 24M</option>
                        <option value="LX EVENT-512/4096 24M" data-select2-id="142">LX EVENT-512/4096 24M</option>
                        <option value="LX EVENT-512/4096 24M" data-select2-id="143">LX EVENT-512/4096 24M</option>
                        <option value="LX EVENT-512/4096 24M" data-select2-id="144">LX EVENT-512/4096 24M</option>
                    </select><span class="select2 select2-container select2-container--default select2-container--below" dir="ltr" data-select2-id="120" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-4f-container"><span class="select2-selection__rendered" id="select2-select-4f-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">Phone number</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
                </div>
            </div>
            <!--<div class="filter-popup-item">
                <div class="item-wrap">
                    <span>Date of creation</span>
                    <div class="calendar-icon">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.166 4.00004H17.4993C17.7204 4.00004 17.9323 4.08784 18.0886 4.24412C18.2449 4.4004 18.3327 4.61236 18.3327 4.83337V18.1667C18.3327 18.3877 18.2449 18.5997 18.0886 18.756C17.9323 18.9122 17.7204 19 17.4993 19H2.49935C2.27834 19 2.06637 18.9122 1.91009 18.756C1.75381 18.5997 1.66602 18.3877 1.66602 18.1667V4.83337C1.66602 4.61236 1.75381 4.4004 1.91009 4.24412C2.06637 4.08784 2.27834 4.00004 2.49935 4.00004H5.83268V2.33337H7.49935V4.00004H12.4993V2.33337H14.166V4.00004ZM12.4993 5.66671H7.49935V7.33337H5.83268V5.66671H3.33268V9.00004H16.666V5.66671H14.166V7.33337H12.4993V5.66671ZM16.666 10.6667H3.33268V17.3334H16.666V10.6667Z" fill="#00AF41"></path>
                        </svg>
                    </div>
                </div>
                <div class="select-result">
                    <div class="date-time-block from">
                        <p class="date"></p>
                        <p class="time"></p>
                    </div>
                    <div class="date-time-block to">
                        <p class="date"></p>
                        <p class="time"></p>
                    </div>
                </div>
                <div class="filter-dropdown-box" style="display: none;">
                    <div class="filter-date-time-box from">
                        <div class="field date filter-wrap-date">
                            <label class="field-name">From</label>
                            <input type="text" class="form-control datepicker" readonly="">
                        </div>
                        <div class="field time filter-wrap-time">
                            <input type="text" class="form-control timepicker" readonly="">
                        </div>

                    </div>
                    <div class="filter-date-time-box to">
                        <div class="field date filter-wrap-date">
                            <label class="field-name">To</label>
                            <input type="text" class="form-control datepicker" readonly="">
                        </div>
                        <div class="field time filter-wrap-time">
                            <input type="text" class="form-control timepicker" readonly="">
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="btn-box">
                <span class="btn light-green reset" @click.prevent="closePopup">Cancel</span>
                <span class="btn success submit" @click.prevent="submitClick">Submit</span>
            </div>
        </div>
    </div>
</template>

<script>

import {mapMutations/*, mapActions, mapState*/} from "vuex"
import IconBase from "../../common/IconBase";
import IconCross from "../../common/icons/IconCross";
import IconFilterArrowDown from "../../common/icons/IconFilterArrowDonw";
import Select2 from "../../Client/MySelect2";
/*import IconBase from "../../common/IconBase";
import IconDeny from "../../common/icons/IconDeny";
import IconSuccess from "../../common/icons/IconSuccess";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Select2 from "../../Client/MySelect2";*/

export default {
    name: 'terminal-filter-form',

    data () {
        return {
            open: false,
            options: [{id: 1, text: 'Vasia'},{id: 2, text: 'Vasia1'},{id: 3, text: 'Vasia3'},],
            searchParam: '',
       /*     customer: '',
            terminal: '',
            moduleId: '',
            subscription: '',
            typeOptions: [],
            subscriptionOptions: [],
            customersOptions: []*/
        }
    },
    components: {
        Select2,
        IconFilterArrowDown,
        IconCross,
        IconBase
/*
        Select2,
        IconSuccess, IconDeny, IconBase
*/
    },

    computed: {
/*
        ...mapState({
            popupData: state => state.popupData,
        }),
        ...mapState('settings', [
            'terminalTypes',
            'subscriptions'
        ]),
        ...mapState('customers', [
            'customers',
        ]),
*/
    },

    mounted() {
        //console.log(this.popupData.item)
/*
        if (this.popupData.type === 'edit') {
            console.log(this.popupData.item)
            this.customer = this.popupData.item.client_id;
            this.terminal = this.popupData.item.type_id;
            this.moduleId = this.popupData.item.core_module_id;
            this.subscription = this.popupData.item.subscription_id;
        }

        this.terminalTypes.forEach(item => {
            this.typeOptions.push({
                id: item.id,
                text: item.name
            })
        });

        this.subscriptions.forEach(item => {
            this.subscriptionOptions.push({
                id: item.id,
                text: item.name
            })
        });

        this.customers.forEach(item => {
            this.customersOptions.push({
                id: item.id,
                text: item.company
            })
        });
*/
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            //'setPopupComponent'
        ]),
        /*...mapActions('terminals', [
            'loadTerminals',
        ]),*/
        openFilterItem() {
            this.open = !this.open
        },
        closePopup() {
            this.switchPopup(false);
        },
        submitClick() {
            console.log('submit click')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
